<template lang="pug">
  v-dialog(
    :value="value"
    @input="close"
    max-width="600px"
  )
    v-card
      v-card-title.headline(v-if="edit") Редактировать набор
      v-card-title.headline(v-else) Добавить набор
        v-spacer
        v-btn(icon)
          v-icon(@click="close") mdi-close
      v-card-text
        validation-observer(ref="obs")
          v-form
            sdo-datetime-field(
              v-model="startDate"
              label-date="Начало набора"
              only-date
            )
            sdo-datetime-field(
              v-model="endDate"
              label-date="Окончание набора"
              only-date
            )
            sdo-datetime-field(
              v-model="startLearning"
              label-date="Дата начала обучения"
              only-date
            )
            sdo-datetime-field(
              v-model="endLearning"
              label-date="Дата окончания обучения"
              only-date
            )

            validation-provider(
              rules="required|integer"
              name="Количество мест"
              vid="number_place"
              v-slot="{ errors, valid }"
            )
              v-text-field(
                v-model="placesCount"
                label="Количество мест"
                :error-messages="errors"
                name="Количество мест"
                type="number"
                rounded filled
              )

      v-divider
      v-card-actions
        v-spacer
        v-btn(
          v-if="!edit"
          color="success"
          @click="createEnrollment"
          :loading="btnLoading"
          text rounded
        ) Добавить набор
        v-btn(
          v-if="edit"
          color="success"
          @click="updateEnrollment"
          :loading="btnLoading"
          text rounded
        ) Изменить набор
        v-btn(color="warning" @click="close" text rounded) Отмена

</template>

<script>

import CourseEnrollmentService from '@/services/API/CourseEnrollmentService';

export default {
  name: 'EnrollmentCreateEditDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    courseId: {
      type: Number,
      default: 0,
      required: true,
    },
    initData: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    startDate: '',
    endDate: '',
    startLearning: null,
    endLearning: null,
    placesCount: '',

    edit: false,
    startDateMenu: false,
    endDateMenu: false,
    btnLoading: false,
  }),
  watch: {
    value(val) {
      if (val) {
        if (Object.keys(this.initData).length) {
          this.startDate = this.initData.period_start;
          this.endDate = this.initData.period_end;
          this.startLearning = this.initData.start_learning;
          this.endLearning = this.initData.end_learning;
          this.placesCount = this.initData.number_place;
          this.edit = true;
        }
      }
    },
  },
  methods: {
    close() {
      this.clearFields();
      this.$emit('input', false);
      this.edit = false;
    },
    createEnrollment() {
      this.btnLoading = true;
      const data = {
        period_start: this.startDate,
        period_end: this.endDate,
        start_learning: this.startLearning,
        end_learning: this.endLearning,
        number_place: this.placesCount,
      };
      this.$rHandler(
        CourseEnrollmentService.createEnrollment(data, this.courseId),
        async (r) => {
          this.btnLoading = false;
          await this.$api.telegram.enrollmentChannel(r.data.data.id);
          this.$emit('update', r.data.data);
          this.close();
        },
        () => { this.btnLoading = false; },
        this.$refs.obs,
      );
    },
    updateEnrollment() {
      this.btnLoading = true;
      const data = {
        id: this.initData.id,
        period_start: this.startDate,
        period_end: this.endDate,
        start_learning: this.startLearning,
        end_learning: this.endLearning,
        number_place: this.placesCount,
      };
      this.$rHandler(
        CourseEnrollmentService.updateEnrollment(data),
        (r) => {
          this.btnLoading = false;
          this.close();
          this.$emit('update', r.data.data);
        },
        () => { this.btnLoading = false; },
        this.$refs.obs,
      );
    },
    clearFields() {
      this.startDate = '';
      this.endDate = '';
      this.placesCount = '';
      this.$refs.obs.reset();
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
